import React from 'react';
import styled from 'styled-components'
import colors from '../../globals/colors'
import { lang } from '../../globals/Translations';
import { ProjectStatusColor, ProjectStatusUILabel } from '../../shared/ProjectStatus'
import { RowFlexBox } from '../templates/Wrappers';

const StatusBoxWrapper = styled.div<{ background: string, border: string }>`
    background-color: ${(p) => p.background};
    padding-left: 16px;
    padding-right: 16px;
    font-size: 14px;
    line-height: 2;
    border-radius: 10px;
    border-style: solid;
    border-width: 1px;
    border-color: ${(p) => p.border};
`

const ProjectStatusBox: React.FC<{ status?: ProjectStatusUILabel }> = ({ status }) => {

    if (!status) return <></>

    let background = "#EBF4FE"
    let forgrund = colors.primary
    if (status && status.color === ProjectStatusColor.GREEN) { forgrund = colors.sucess; background = "#F0FAF3" }
    if (status && status.color === ProjectStatusColor.GRAY) {forgrund = colors.grayText; background = "#F5F5F5"}
    if (status && status.color === ProjectStatusColor.RED) {forgrund = colors.danger; background = "#FFEBEB"}
    if (status && status.color === ProjectStatusColor.YELLOW) { forgrund = colors.warning; background = "#FFF8EB" }

    return (
        <RowFlexBox>
            <StatusBoxWrapper background={background} border={forgrund}>
                <span style={{ color: forgrund }}>{lang(status.name)}</span>
            </StatusBoxWrapper>
        </RowFlexBox>
    );
};

export default ProjectStatusBox;